
import ReviewsViewTabSectionMainContentReviewsListReviewsRating from './ReviewsRating.vue';
import ReviewsViewLazyImage from '../../../LazyImage.vue';

export default {
  name: 'ReviewsViewTabSectionMainContentReviewsListItem',
  components: {
    ReviewsViewTabSectionMainContentReviewsListReviewsRating,
    ReviewsViewLazyImage,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
    rating: {
      type: Number,
      default: 5,
    },
    starColor: {
      type: String,
      default() {
        return this.$cp.primary_support;
      },
    },
    starColorBoutique: {
      type: String,
      default() {
        return this.$cp.tertiary_specialMain;
      },
    },
  },
  data() {
    return {
      isImgLoaded: new Array(1).fill(false),
      imageUrl: '/skin/frontend/onestopbedrooms/default/images/review-icon',
    };
  },
  computed: {
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
    starStyle() {
      return {
        fullStarColor: this.isBoutiquePage ? this.starColorBoutique : this.starColor,
        emptyStarColor: this.$cp.white,
        starWidth: 14,
        starHeight: 14,
      };
    },
    badgeReviewImage() {
      const imageMap = {
        google: 'icon_sb_google',
        reseller_ratings: 'icon_sb_reseller_rating',
        trust_pilot: 'icon_sb_trustpilot',
        site_jabber: 'icon_sb_sitejabber',
        shopper_approved: 'icon_sb_shopper',
        ekomi: 'icon_sb_ekomi',
        reviews_io: 'icon_sb_reviews',
      };
      const imageName = imageMap[this.review.type] || imageMap.google;

      return {
        src: `${this.$config.cdnBaseUrl}${this.imageUrl}/${imageName}_logo_list_d.png`,
        alt: `${this.review.type} Review Logo`,
        sources: [
          {
            srcset: `${this.$config.cdnBaseUrl}${this.imageUrl}/${imageName}_logo_list_m.png`,
            media: '(max-width: 767px)',
          },
          {
            srcset: `${this.$config.cdnBaseUrl}${this.imageUrl}/${imageName}_logo_list_d.png`,
            media: '(min-width: 768px)',
          },
        ],
      };
    },
  },
  methods: {
    load(index) {
      this.$set(this.isImgLoaded, index, true);
    },
  },
};
